export type RouterNavigationType = 'push' | 'replace' | 'traverse';

let historyEntryPathname: string | null = null;

const toPathname = (url: string) => new URL(url, window.location.href).pathname;

export const trackDocumentNavigation = () => {
  const [navigation] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];

  historyEntryPathname = navigation?.type === 'back_forward' ? toPathname(navigation.name) : null;
};

export const trackRouterNavigation = (url: string, navigationType: RouterNavigationType) => {
  if (navigationType === 'traverse') {
    historyEntryPathname = toPathname(url);
    return;
  }

  if (navigationType === 'push') {
    historyEntryPathname = null;
  }
};

export const isHistoryNavigation = () => historyEntryPathname === window.location.pathname;
